// Issue: https://gitlab.fhnw.ch/webteam/fhnw-webauftritt-2025/-/issues/847
// Customization comparison with @kitconcept/volto-button-block/src/components/View.jsx:
// - Removed the MaybeWrap component from the final render and simplified the return logic.
// - Changed the link rendering: in view mode, it uses a plain <a> tag; in edit mode, it uses ConditionalLink with an added 'item' prop.
// - Removed the MaybeWrap import.

import React from 'react';
import { Button } from 'semantic-ui-react';
import cx from 'classnames';
import { ConditionalLink } from '@plone/volto/components';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  ButtonText: {
    id: 'Button text',
    defaultMessage: 'Button text',
  },
});

const LegacyWrapper = (props) => (
  <div className={cx('block __button', props.className)} style={props.style}>
    <div className="button container">
      <div className={cx('align', props.data?.inneralign)}>
        {props.children}
      </div>
    </div>
  </div>
);

const View = (props) => {
  const { data, isEditMode, blocksConfig } = props;
  const [hasLink, setHasLink] = React.useState(false);
  const intl = useIntl();
  const isBlockModelv3 = blocksConfig?.__button?.blockModel === 3;

  React.useEffect(() => {
    if (data.href) {
      if (data.href && data.href.length > 0) {
        setHasLink(true);
      }
      if (data.href.length === 0) {
        setHasLink(false);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.href]);

  let link;
  if (hasLink && data.href.length > 0) {
    if (isEditMode) {
      link = (
        <ConditionalLink
          to={data.href[0]?.['@id']}
          condition={!isEditMode}
          openLinkInNewTab={data.openLinkInNewTab}
          item={data.href[0]}
        >
          <Button className={(cx('button'), data.align)}>
            {data.title || intl.formatMessage(messages.ButtonText)}
          </Button>
        </ConditionalLink>
      );
    } else {
      // Render as <a> tag in view mode when link exists
      link = (
        <a href={data.href[0]?.['@id']} className={(cx('button'), data.align)}>
          {data.title || intl.formatMessage(messages.ButtonText)}
        </a>
      );
    }
  } else {
    // Render as button with noLink class when no link exists
    link = (
      <Button className="noLink">
        {data.title || intl.formatMessage(messages.ButtonText)}
      </Button>
    );
  }

  return !isBlockModelv3 ? (
    <LegacyWrapper {...props}>{link}</LegacyWrapper>
  ) : (
    link
  );
};

export default View;
